var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    fill: "#22CF4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 25V35L35.25 36.25L31.3875 29.375C31.0625 28.8 30.15 29.0875 30.25 29.7625L31.5 41.25L19 36.25L20.4375 26.175C20.7323 24.1141 21.7605 22.2288 23.3334 20.8649C24.9062 19.501 26.9182 18.7501 29 18.75H39L37.025 21.7125C38.2 22.35 39 23.575 39 25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp);
export default __webpack_public_path__ + "static/media/HP.55905a45a3633ac8bb97c5b7901ac0b5.svg";
export { ForwardRef as ReactComponent };